module.exports = __webpack_public_path__ + "static/img/icon5.6d01c3a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon5.jpg
// module id = IBuw
// module chunks = 0